import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { track } from '../../utils/analytics';

export default function FirstReportCard() {
  return (
    <section className="mb-8 w-full rounded-card border border-navy/15 bg-paper p-5 shadow-card sm:p-6">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <h2 className="font-display text-xl font-bold text-ink">Crie seu primeiro laudo agora.</h2>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-muted">Leva cerca de 2 minutos.</p>
        </div>
        <div className="flex w-full shrink-0 flex-col gap-3 sm:w-auto sm:flex-row">
          <Link
            to="/modelos"
            onClick={() => track('first_report_card_clicked', { action: 'browse_templates' })}
            className="btn-secondary w-full justify-center sm:w-auto"
          >
            Ver modelos
          </Link>
          <Link
            to="/novo-laudo"
            onClick={() => track('first_report_card_clicked', { action: 'first_report_direct' })}
            className="btn-convert w-full justify-center sm:w-auto"
          >
            Criar meu primeiro laudo <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
